import { FC } from 'react';
import SearchFormItem from './subpage/searchFormItem';
import SuperUpload from '../SuperUpload';
import { UploadImagesProps } from '../SuperUpload/uploadImages';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormUploadImagesProps extends BaseSearchFormItemProps {
  uploadImagesProps?: UploadImagesProps;
}
/** 上传多张图片 */
export const SearchFormUploadImages: FC<SearchFormUploadImagesProps> = props => {
  const {
    uploadImagesProps,
    name,
    isDetail,
    form,
    testId,
    ...resProps
  } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  return (
    <SearchFormItem
      name={name}
      form={form}
      {...resProps}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      test-id={`${testId}-${name}`}
    >
      <SuperUpload.Images disabled={isDetail} {...uploadImagesProps} />
    </SearchFormItem>
  );
};

SearchFormUploadImages.displayName = SearchFormItemEnum.SearchFormUploadImages;

export default SearchFormUploadImages;
